var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_3166",
    "data-name": "\\uADF8\\uB8F9 3166",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 16,
    viewBox: "0 0 50 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3041",
    "data-name": "\\uC0AC\\uAC01\\uD615 3041",
    width: 50,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3165",
    "data-name": "\\uADF8\\uB8F9 3165",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11354",
    "data-name": "\\uD328\\uC2A4 11354",
    d: "M1411.089,189.815v-6.073h2.156V194.38c-.283,0-.571.008-.858-.006a.378.378,0,0,1-.2-.126q-1.983-1.961-3.962-3.925-.962-.953-1.929-1.9c-.04-.04-.085-.075-.161-.142v6.1h-2.144v-10.66c.281,0,.564-.005.847,0,.052,0,.107.061.151.1q1.531,1.512,3.059,3.027,1.455,1.433,2.92,2.857c.03.029.062.055.125.109",
    transform: "translate(-1363.246 -178.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11355",
    "data-name": "\\uD328\\uC2A4 11355",
    d: "M270.59,183.64a5.348,5.348,0,0,1,2.558,10.036,4.57,4.57,0,0,1-1.818.624,5.739,5.739,0,0,1-.956.005,5.612,5.612,0,0,1-1.627-.308,5.092,5.092,0,0,1-3.4-3.853,5.17,5.17,0,0,1,1.4-4.9,5.03,5.03,0,0,1,2.985-1.522c.286-.042.575-.057.863-.085m-.048,8.539a3.19,3.19,0,1,0-3.18-3.22,3.188,3.188,0,0,0,3.18,3.22",
    transform: "translate(-257.512 -178.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11356",
    "data-name": "\\uD328\\uC2A4 11356",
    d: "M663.286,191.163v3.119h-2.124V183.619h.151q1.7,0,3.409,0a4.83,4.83,0,0,1,2.273.453,3.418,3.418,0,0,1,1.939,2.627,3.734,3.734,0,0,1-1.565,3.729c-.072.055-.146.108-.225.166l2.233,3.687c-.062,0-.106.008-.151.008-.75,0-1.5,0-2.249,0a.258.258,0,0,1-.253-.147c-.555-.937-1.116-1.872-1.668-2.811a.314.314,0,0,0-.313-.177c-.478.008-.956,0-1.458,0m.009-2.168c.045,0,.074.007.1.007h1.9a.865.865,0,0,0,.158-.013,1.72,1.72,0,0,0,1.306-2.178,1.676,1.676,0,0,0-1.57-1.115c-.595-.007-1.189,0-1.784,0a1.012,1.012,0,0,0-.113.013Z",
    transform: "translate(-641.976 -178.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11357",
    "data-name": "\\uD328\\uC2A4 11357",
    d: "M0,183.691H.593c.445,0,.89.006,1.335,0,.144,0,.188.035.187.184-.006,1.481,0,2.962,0,4.443v.166l.038.013c.147-.188.3-.374.439-.563q1.562-2.049,3.12-4.1a.4.4,0,0,1,.341-.154c.89,0,1.779,0,2.669,0,0,0,.007,0,.025.017-.037.052-.072.107-.112.159q-1.852,2.411-3.707,4.819a.179.179,0,0,0,0,.262q1.96,2.628,3.913,5.26c.031.042.061.085.1.144-.058,0-.1.007-.139.007-.783,0-1.567,0-2.35,0a.316.316,0,0,1-.279-.142q-1.378-1.825-2.761-3.646c-.029-.038-.058-.075-.1-.124-.218.24-.428.472-.64.7-.144.157-.3.3-.43.469a.505.505,0,0,0-.107.283c-.014.771-.017,1.543-.024,2.314,0,.042-.007.084-.011.132H0Z",
    transform: "translate(0 -178.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11358",
    "data-name": "\\uD328\\uC2A4 11358",
    d: "M977.33,192.213V195.4h-2.152V184.765h7.83v2.124h-5.666v3.169h4.228v2.155Z",
    transform: "translate(-946.879 -179.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3038",
    "data-name": "\\uC0AC\\uAC01\\uD615 3038",
    width: 2.177,
    height: 10.652,
    transform: "translate(37.206 5.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11359",
    "data-name": "\\uD328\\uC2A4 11359",
    d: "M956.9.369h.432V4.4h-2.709c0-.046-.007-.1-.007-.148,0-.453,0-.907,0-1.36a.221.221,0,0,0-.1-.2.814.814,0,0,1-.4-.683.775.775,0,0,1,.282-.564c.073-.069.159-.125.267-.209h-.776V.8h1.03V.316h.424c0,.1,0,.192,0,.287,0,.192,0,.192.187.192h.865v.427h-.739l-.01.032.411.329.017-.245h.511c.311,0,.311,0,.311-.315V.369M956.877,2.5H956.6a2.967,2.967,0,0,1-.461-.014c-.078-.013-.116-.016-.167.046a.8.8,0,0,1-.517.289c-.126.019-.254.029-.383.043V3.28h1.806Zm-1.141-.484a1.309,1.309,0,0,0-.193-.277.719.719,0,0,0-.813-.006.33.33,0,0,0-.022.552.719.719,0,0,0,.883-.014c.064-.046.087-.149.145-.255m-.658,1.958h1.8c.043-.246.037-.253-.188-.253h-1.432c-.223,0-.23.01-.184.253m1.8-2.212h-.755c0,.046,0,.08,0,.113-.009.146.051.209.2.191a2.9,2.9,0,0,1,.332,0c.262,0,.265,0,.233-.268a.156.156,0,0,0-.015-.033",
    transform: "translate(-926.213 -0.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11360",
    "data-name": "\\uD328\\uC2A4 11360",
    d: "M815.943,1.442h-.718a1.037,1.037,0,0,1-.422.638,1.291,1.291,0,0,1-1.382-.011A1.043,1.043,0,0,1,813.03.952a1.022,1.022,0,0,1,.83-.752,1.3,1.3,0,0,1,.919.156.893.893,0,0,1,.4.527.136.136,0,0,0,.162.118c.15,0,.3-.007.449,0,.118.006.161-.03.158-.154-.008-.279,0-.558,0-.849h.481V4.1H813.7V2.5h.472V2.94h1.769ZM814.127.657a.584.584,0,1,0-.009,1.162.6.6,0,0,0,.644-.578.591.591,0,0,0-.635-.584m1.818,2.734c-.055,0-.1-.009-.14-.009-.493,0-.985,0-1.478,0-.126,0-.151.045-.153.159s.029.168.161.166c.488-.008.975,0,1.463,0,.047,0,.093-.006.146-.009Z",
    transform: "translate(-789.404 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11361",
    "data-name": "\\uD328\\uC2A4 11361",
    d: "M102.459,4.741v1.5h-.446V5.2H99.447a2.868,2.868,0,0,1,.006-.356c0-.032.076-.077.118-.078.334-.006.667,0,1,0h.181V4.22H99.079l-.022-.279h-.551V5.309h-.437V2.177h.425V3.5h.656l.016.25c.048,0,.09.009.132.009.822,0,1.644,0,2.466,0,.12,0,.155-.037.162-.154.013-.235.045-.469.068-.7,0-.037,0-.074.007-.129H99.551V2.384h2.886l-.058,1.375h.543v.434c-.059,0-.116.008-.172.008-.459,0-.919,0-1.378,0-.106,0-.15.029-.143.139.008.129,0,.259,0,.4Z",
    transform: "translate(-95.223 -2.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11362",
    "data-name": "\\uD328\\uC2A4 11362",
    d: "M1088.211,1.371v.511h1.107V2.31h-.911l-.01.035c.044.022.087.046.132.066a.843.843,0,0,1,.5.819.853.853,0,0,1-.656.724c-.178.041-.19.062-.144.259l1.032-.09a.529.529,0,0,1,.1-.011c.115.013.136-.048.135-.147,0-.405,0-.81,0-1.216V1.4h.412c0,.06.009.116.009.172q0,1.86,0,3.719c0,.06-.023.169-.047.172a1.413,1.413,0,0,1-.344,0c-.013,0-.027-.076-.027-.117,0-.264,0-.529,0-.814-.163.016-.309.036-.455.043q-1.114.051-2.228.095c-.228.009-.228,0-.271-.219-.011-.056-.021-.112-.035-.188.063,0,.113-.011.164-.011h.943c.066,0,.143.014.141-.093,0-.082.015-.168-.108-.182a.8.8,0,0,1-.18-.051.745.745,0,0,1-.545-.659.784.784,0,0,1,.449-.844.318.318,0,0,0,.119-.089h-.843V1.909c.061,0,.126-.01.192-.01.266,0,.532,0,.8,0,.087,0,.123-.029.12-.117,0-.134,0-.268,0-.411Zm-.259,1.318a2.548,2.548,0,0,0-.476.206.319.319,0,0,0,.039.544.843.843,0,0,0,.889.014.331.331,0,0,0,.017-.6,2.792,2.792,0,0,0-.469-.168",
    transform: "translate(-1054.978 -1.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11363",
    "data-name": "\\uD328\\uC2A4 11363",
    d: "M533.3,19.857h2.908l.005-.029L536,19.776l.164-1.051c-.068,0-.123,0-.178,0-.723.039-1.446.076-2.169.12-.1.006-.142-.023-.163-.125-.061-.3-.139-.3.233-.312.651-.024,1.3-.054,1.953-.085.1,0,.2-.024.308-.037v-.628h-2.421v-.425h2.882a11.891,11.891,0,0,1-.169,2.616h.684v.406H533.3Z",
    transform: "translate(-517.823 -16.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11364",
    "data-name": "\\uD328\\uC2A4 11364",
    d: "M408.76,9.912h-.395V7.961l-1.768.06v.7a5.4,5.4,0,0,0,1.5-.129c.01.011.015.014.016.018.128.388.126.374-.282.448a8.561,8.561,0,0,1-1.589.079c-.023,0-.046,0-.077-.007V6.543h1.717v.4h-1.29v.651c.217,0,.433.007.648,0,.308-.012.616-.039.924-.05.149-.005.206-.055.2-.214-.014-.332,0-.666,0-1V6.166h.4Z",
    transform: "translate(-394.38 -5.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11365",
    "data-name": "\\uD328\\uC2A4 11365",
    d: "M0,3.248V2.817H1.084V2.3h.422v.511H2.6v.425H1.8l-.014.032c.048.032.095.068.146.1a.747.747,0,0,1,.433.768.777.777,0,0,1-.631.7A1.576,1.576,0,0,1,.751,4.8a.742.742,0,0,1-.517-.714.757.757,0,0,1,.421-.736.476.476,0,0,0,.145-.1Zm1.317.364a3.426,3.426,0,0,0-.466.155.329.329,0,0,0-.065.546.913.913,0,0,0,.993.019.313.313,0,0,0-.012-.542,3.056,3.056,0,0,0-.451-.178",
    transform: "translate(0 -2.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11366",
    "data-name": "\\uD328\\uC2A4 11366",
    d: "M269.142,15.995c-.121,0-.227-.006-.332,0-.037,0-.1.041-.1.064-.007.364,0,.729,0,1.109l.673-.06.046.412c-.192.021-.372.051-.553.059-.574.026-1.147.043-1.721.065-.116,0-.231.014-.346.025-.089.008-.133-.024-.143-.117s-.037-.2-.06-.313c.17,0,.324-.005.477,0,.1,0,.145-.023.143-.136-.007-.36,0-.721,0-1.1a2.912,2.912,0,0,1-.342,0,.146.146,0,0,1-.1-.1c-.035-.318-.031-.318.287-.318h2.081Zm-1.46.031v1.188c.154,0,.3.006.442,0,.038,0,.1-.055.1-.085.007-.364,0-.728,0-1.1Z",
    transform: "translate(-258.862 -15.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3039",
    "data-name": "\\uC0AC\\uAC01\\uD615 3039",
    width: 0.46,
    height: 4.115,
    transform: "translate(14.722 0.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11367",
    "data-name": "\\uD328\\uC2A4 11367",
    d: "M672.858,14.1l-.254.375a1.806,1.806,0,0,1-1.009-.769,3.109,3.109,0,0,1-.383.454,4.26,4.26,0,0,1-.61.376.137.137,0,0,1-.124-.035c-.077-.091-.142-.194-.219-.3.074-.031.14-.058.2-.087a1.319,1.319,0,0,0,.856-1.3c0-.139,0-.279,0-.428h.489v.337a1.287,1.287,0,0,0,.908,1.327c.04.016.081.03.142.052",
    transform: "translate(-650.809 -12.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11368",
    "data-name": "\\uD328\\uC2A4 11368",
    d: "M769.227,3.7V.563c.142,0,.277-.007.409.006.03,0,.074.078.075.12.007.313,0,.627,0,.94v.187h.6v.431c-.16,0-.313.005-.466,0-.1,0-.135.033-.134.133,0,.391,0,.781,0,1.172,0,.12-.036.164-.156.155s-.219,0-.334,0",
    transform: "translate(-746.905 -0.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11369",
    "data-name": "\\uD328\\uC2A4 11369",
    d: "M290.645,92.262h2.4v.4H290.2V91.268h.444Z",
    transform: "translate(-281.78 -88.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11370",
    "data-name": "\\uD328\\uC2A4 11370",
    d: "M693.362,91.231h.439v.991h2.4v.407h-2.841Z",
    transform: "translate(-673.241 -88.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11371",
    "data-name": "\\uD328\\uC2A4 11371",
    d: "M24.914,94.626H22.072V93.287h.4c0,.264.006.523,0,.782,0,.122.037.156.156.156.706,0,1.412,0,2.118-.005.142,0,.193.041.176.18a1.959,1.959,0,0,0,0,.227",
    transform: "translate(-21.431 -90.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3040",
    "data-name": "\\uC0AC\\uAC01\\uD615 3040",
    width: 0.439,
    height: 3.129,
    transform: "translate(10.743 0.037)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo4);
export default __webpack_public_path__ + "static/media/footer-logo4.1720430a66f7d840102682c82008cc92.svg";
export { ForwardRef as ReactComponent };